import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-loading',
    imports: [MatProgressSpinnerModule, RouterModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './loading.component.html',
})
export class LoadingComponent {
    loading$ = this.loadingService.loading$;

    constructor(private loadingService: LoadingService) {}
}
